import Navbar from '../components/navbar';
import SpecialCollection from '../components/homepage/specialCollection';
import AboutMERL from '../components/homepage/aboutMERL';
import Footer from '../components/footer';
import '../App.scss';

const Home = () => {

	document.title = "Special Collection — The Walt Disney Company";
    return (
		<div className="App">
			<header>
				<Navbar></Navbar>
			</header>

			
		  
			<body> <div className='gray-primary text-white'> <br/><br/><br/>
			<h1 className='text-white'> Special Collection: The Walt
			Disney Company</h1> <p className='jump-to'>Jump to <a
			href="/waltdisneycompany#fx">FX</a>, <a
			href="/waltdisneycompany#marvel">Marvel</a>, <a
			href="/waltdisneycompany#hulu">Hulu</a>, <a
			href="/waltdisneycompany#starwars">Star Wars</a>, <a
			href="/waltdisneycompany#disney">Disney</a> </p> <br/><br/><br/> </div>

				<div id="fx">
					<SpecialCollection
						titles={"Fosse/Verdon-s1, Pose-s2, Pose-s3, What We Do in the Shadows-s4, Reservation Dogs-s1"}
						sectionName={"FX TV"}/>
				</div>
				<div className='white' >
					<br/><br/><br/>	
				</div>

				<div id='marvel'>
					<SpecialCollection
						titles={"WandaVision-s1, Spider-Man: Far From Home, Spider-Man: No Way Home, Avengers: Endgame, Captain Marvel, Doctor Strange in the Multiverse of Madness, Thor: Love and Thunder, Black Panther: Wakanda Forever, Black Widow, Eternals, Shang-Chi and the Legend of the Ten Rings"}
						sectionName={"Marvel Films and TV"}/>
				</div>
				<div className='white' >
					<br/><br/><br/>	
				</div>

				<div id='hulu'>
					<SpecialCollection
						titles={"Free Guy, The Call of the Wild, Normal People-s1, Reservation Dogs-s1, Only Murders in the Building-s1, The Dropout-s1, The Great-s2, Jumanji: The Next Level, Spider-Man: Far From Home, Spider-Man: No Way Home, Interior Chinatown-s1, Pen15-s1, The Dropout-s1"}
						sectionName={"Hulu Films and TV"}/>
				</div>
				<div className='white' >
					<br/><br/><br/>	
				</div>

				<div id='starwars'>
					<SpecialCollection
						titles={"Andor-s1, Star Wars: Episode IX - The Rise of Skywalker"}
						sectionName={"Star Wars Films"}/>
				</div>
				<div className='white' >
					<br/><br/><br/>	
				</div>

				<div id='disney'>
				<SpecialCollection
						titles={"Abbott Elementary-s1, Andor-s1, Onward, The Lion King, Thor: Love and Thunder, Aladdin, Black Panther: Wakanda Forever, Frozen 2, Toy Story 4, Turning Red, Moana 2, Interior Chinatown-s1"}
						sectionName={"Disney Films and TV"}/>
				</div>
				
				<Footer/>
			</body>
		</div>
	  );
}

export default Home;
